<td tabindex="0" class="user-id {{classPersonStatus}}">
    <p class="username" *ngIf="user.username || user.email" [class.deactivated]="!user.active" [innerHTML]="user.username | highlighter: filterText"></p>
    <p class="email" *ngIf="user.email !== user.username" [class.deactivated]="!user.active" [innerHTML]="user.email | highlighter: filterText"></p>
</td>
<td class="icon roles">
    <ng-container *ngIf="selectedRoles.length > 1">
        <div class="button-wrapper">
            <app-button
                    [cssClasses]="'icon solid__white wh-52'"
                    [icon]="'list'"
                    [iconColor]="'gray-06'"
                    (buttonClicked)="this.onEditUserRoles(this.user.userId);">
            </app-button>
        </div>
    </ng-container>
    <ng-container *ngIf="selectedRoles.length === 1">
        <div class="button-wrapper" *ngFor="let role of selectedRoles">
            <app-button
                    [cssClasses]="'icon solid__white wh-52'"
                    [icon]="!iconsForOtherRoles(role) && this.patientRole ? 'person' : ''"
                    [customIcon]="iconsForOtherRoles(role)"
                    [iconColor]="'gray-06'"
                    [disabled]="!user.active"
                    (buttonClicked)="this.onEditUserRoles(this.user.userId);">
            </app-button>
        </div>
    </ng-container>
</td>
<td class="icon more-info-icon">
    <ng-container *ngFor="let role of selectedRoles">
        <div class="button-wrapper" *ngIf="role === patientRole">
            <app-button
                    [ariaLabel]="'SCREEN_READER.USER_MORE_INFO' | translate"
                    [cssClasses]="'icon solid__white wh-52'"
                    [icon]="'info'"
                    [iconColor]="'gray-06'"
                    [disabled]="!user.active"
                    (buttonClicked)="onOpenPopUpMoreInfo(user.userId)">
            </app-button>
        </div>
    </ng-container>
</td>
<td class="icon education-icon">
    <ng-container *ngFor="let role of selectedRoles">
        <div class="button-wrapper" *ngIf="role === patientRole">
            <app-button
                    [cssClasses]="'icon solid__white wh-52'"
                    [icon]="'local_library'"
                    [iconColor]="hasEducation ? 'gray-06' : 'red-07'"
                    [disabled]="!user.active"
                    (buttonClicked)="educationPopUpEvent.emit(user.userId)">
            </app-button>
        </div>
    </ng-container>
</td>
<td class="icon permissions-icon">
    <ng-container *ngFor="let role of selectedRoles">
        <div class="button-wrapper" *ngIf="role === patientRole">
            <app-button
                    [disabled]="!hasEducation || !user.active"
                    [ariaLabel]="'SCREEN_READER.USER_PERMISSIONS' | translate"
                    [cssClasses]="'icon solid__white wh-52'"
                    [icon]="'settings'"
                    [iconColor]="'gray-06'"
                    (buttonClicked)="onOpenPopUpPermissions(user)">
            </app-button>
        </div>
    </ng-container>
</td>
<td class="icon actions-icon">
    <div class="button-wrapper">
        <app-dropdown-button
                [disabled]="currentLoggedUser"
                [triggerData]="triggerData"
                [menuItems]="menuItems"
                (buttonEvent)="buttonActions($event)">
        </app-dropdown-button>
    </div>
</td>
